import { render, staticRenderFns } from "./ShipDesign.vue?vue&type=template&id=5c1d12ee&scoped=true&"
import script from "./ShipDesign.vue?vue&type=script&lang=js&"
export * from "./ShipDesign.vue?vue&type=script&lang=js&"
import style0 from "./ShipDesign.vue?vue&type=style&index=0&id=5c1d12ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d12ee",
  null
  
)

export default component.exports